module.exports = __webpack_public_path__ + "img/galerie-22.82191095.jpg";